// extracted by mini-css-extract-plugin
export default {"root":"PlanTabs_root__vLP3I","tab":"PlanTabs_tab__Ka4rd","active":"PlanTabs_active__MaJy8"};